import { computed, ref } from 'vue'
import messages from '../i18n/messages'

const STORE_KEY = 'lang'
const currentLang = ref(localStorage.getItem(STORE_KEY) || 'en')
const listeners = new Set()

export function t(key, fallback = '') {
  const dict = messages[currentLang.value] || messages.en
  const parts = key.split('.')
  let cur = dict
  for (const p of parts) {
    if (cur && typeof cur === 'object' && p in cur) cur = cur[p]
    else return fallback || key
  }
  // 允许对象/数组（用于 FAQ items 等）
  if (cur && typeof cur === 'object') return cur
  return typeof cur === 'string' ? cur : (fallback || key)
}

export function setLang(lang) {
  const newLang = ['en','zh','fr'].includes(lang) ? lang : 'en'
  currentLang.value = newLang
  localStorage.setItem(STORE_KEY, newLang)
  listeners.forEach(fn => { try { fn(newLang) } catch(_){} })
}

export function getLang() {
  return currentLang.value
}

export function onLangChange(fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

export function useI18n() {
  return {
    t,
    setLanguage: setLang,
    currentLang: computed(() => currentLang.value)
  }
}
